import { css, styled } from 'canoe';

import { ContentCard } from '@candu-ai/content/list';

export const ExperimentFormCard = styled(ContentCard)`
  ${({ theme }) => css`
    padding: ${theme.spaces.xs};
    display: flex;
    align-items: center;
    gap: ${theme.spaces.xs};
    flex: 1;
  `}
`;
